// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__ffs6t","detailsBorder":"styles_detailsBorder__Xj7gY"};